
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import WhatIDo from './components/WhatIDo';
import Portfolio from './components/Portfolio';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WelcomePopup from './components/WelcomePopup';

export default function HomePage() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    if (isFormOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isFormOpen]);

  return (
    <div className="min-h-screen">
      <Hero onGetStarted={() => setIsFormOpen(true)} />
      <About />
      <WhatIDo />
      <Portfolio />
      <Services onGetStarted={() => setIsFormOpen(true)} />
      <Contact onGetStarted={() => setIsFormOpen(true)} />
      <Footer />
      <WelcomePopup isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </div>
  );
}
